import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { FaCog, FaPlusCircle } from 'react-icons/fa';
import * as Motion from 'motion/react';
import DashboardList, { DashboardProtocolListRenderComponent } from '../../components/DashboardList';
import Loader from '../../components/Loaders';
import useDialogBox from '../../hooks/useDialogBox';
import { createProtocol, getProtocols } from '../../api/v1/protocols';
import { animationStaggeredItem } from '../../animations';
import '../../styles/screen.scss';

const { motion } = Motion;


const Protocols = () => {
  const formRef = useRef(null);
  const [protocols, setProtocols] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { resetDialogBox, setDialogBox } = useDialogBox();

  const loadProtocolList = async () => {
    const result = await getProtocols();

    setProtocols(result?.data);
  };

  const createProtocolSubmit = async () => {
    const { isTemplate, protocolName } = formRef.current?.getValues();

    await createProtocol({
      isTemplate,
      protocolName
    });

    resetDialogBox();

    await loadProtocolList();
  };

  const newProtocol = async () => {
    setDialogBox({
      title: 'Add Protocol',
      content: <AddProtocolForm ref={formRef}/>,
      actions: [
        { title: 'Create Protocol', type: 'primary', action: () => createProtocolSubmit() },
        { title: 'Cancel', type: 'cancel', action: () => resetDialogBox() }
      ]
    });
  };

  useEffect(() => {
    (async () => {
      await loadProtocolList();
      setIsLoading(false);
    })();
  }, []);

  return (
    <>
      <Motion.AnimatePresence>
        {isLoading && <Loader/>}
      </Motion.AnimatePresence>

      <motion.div variants={animationStaggeredItem} className="screen-header">
        <div className="screen-title-wrapper">
          <h2 className="screen-title">
            <FaCog/>
            Protocols
          </h2>
        </div>

        <button className="screen-header-button primary" onClick={() => newProtocol()}>
          <FaPlusCircle/>Add Protocol
        </button>
      </motion.div>

      <DashboardList items={protocols} RenderComponent={DashboardProtocolListRenderComponent}/>
    </>
  )
};

const AddProtocolForm = forwardRef((props, ref) => {
  const [protocolName, setProtocolName] = useState('');
  const [isTemplate, setIsTemplate] = useState(false);

  const getValues = () => {
    return { isTemplate, protocolName };
  };

  useImperativeHandle(ref, () => ({
    getValues,
  }));

  return (
    <div className="modal-form">
      <div className="form-group">
        <label>Protocol Name</label>
        <input name="protocol-name" placeholder="Protocol Name" value={protocolName}
               onChange={(e) => setProtocolName(e.target.value)}/>
      </div>

      <div className="form-group-row">
        <label>Is Template</label>
        <input type="checkbox" checked={isTemplate} onChange={(e) => setIsTemplate(e.target.checked)}/>
      </div>
    </div>
  );
});

export default Protocols;
